import React, { FC }             from "react";
import { useDispatch, useStore } from "react-redux";
import { Form, Input }           from "semantic-ui-react";
import Corporation               from "../../../../domain/corporation/Corporation";
import CorporationName           from "../../../../domain/corporation/CorporationName";
import CorporationNameKana       from "../../../../domain/corporation/CorporationNameKana";
import CorporationRepository     from "../../../../domain/corporation/CorporationRepository";
import Building                  from "../../../../domain/fundamentals/address/Building";
import City                      from "../../../../domain/fundamentals/address/City";
import PostalCode                from "../../../../domain/fundamentals/address/PostalCode";
import Prefecture                from "../../../../domain/fundamentals/address/Prefecture";
import Street                    from "../../../../domain/fundamentals/address/Street";
import Email                     from "../../../../domain/fundamentals/email/Email";
import FirstName                 from "../../../../domain/fundamentals/name/FirstName";
import FirstNameKana             from "../../../../domain/fundamentals/name/FirstNameKana";
import LastName                  from "../../../../domain/fundamentals/name/LastName";
import LastNameKana              from "../../../../domain/fundamentals/name/LastNameKana";
import Phone                     from "../../../../domain/fundamentals/phone/Phone";
import CorporationDataSource     from "../../../../infrastructure/datasource/corporation/CorporationDataSource";
import AddressFormField          from "../../common/AddressFormField";
import ValidatorMessage          from "../../message/ValidatorMessage";

const CorporationSettingForm: FC = () => {
  const corporation: Corporation = useStore().getState().corporation;
  const repository: CorporationRepository = new CorporationDataSource(useDispatch());
  return (
    <>
      <Form>
        <Form.Field required>
          <label>法人名</label>
          <Input
            defaultValue={ corporation.name.value }
            onChange={ (event, data) => repository.setCorporationName(new CorporationName(data.value)) }
          />
          <ValidatorMessage target="name"/>
        </Form.Field>
        <Form.Field required>
          <label>法人名カナ</label>
          <Input
            defaultValue={ corporation.nameKana.value }
            onChange={ (event, data) => repository.setCorporationNameKana(new CorporationNameKana(data.value)) }
          />
          <ValidatorMessage target="name_kana"/>
        </Form.Field>
        <Form.Field required>
          <label>電話番号</label>
          <Input
            defaultValue={ corporation.phone.value }
            onChange={ (event, data) => repository.setCorporationPhone(new Phone(data.value)) }
          />
          <ValidatorMessage target="phone_number"/>
        </Form.Field>

        <Form.Group>
          <Form.Field required>
            <label>申込者氏名(姓)</label>
            <Input
              defaultValue={ corporation.applicant.name.lastName.value }
              onChange={ (event, data) => repository.setCorporationApplicantLastName(new LastName(data.value)) }
            />
            <ValidatorMessage target="applicant.last_name"/>
          </Form.Field>
          <Form.Field required>
            <label>申込者氏名(名)</label>
            <Input
              defaultValue={ corporation.applicant.name.firstName.value }
              onChange={ (event, data) => repository.setCorporationApplicantFirstName(new FirstName(data.value)) }
            />
            <ValidatorMessage target="applicant.first_name"/>
          </Form.Field>
        </Form.Group>
        <Form.Group>
          <Form.Field required>
            <label>申込者氏名カナ(姓)</label>
            <Input
              defaultValue={ corporation.applicant.name.lastNameKana.value }
              onChange={ (event, data) => repository.setCorporationApplicantLastNameKana(new LastNameKana(data.value)) }
            />
            <ValidatorMessage target="applicant.last_name_kana"/>
          </Form.Field>
          <Form.Field required>
            <label>申込者氏名カナ(名)</label>
            <Input
              defaultValue={ corporation.applicant.name.firstNameKana.value }
              onChange={ (event, data) => repository.setCorporationApplicantFirstNameKana(new FirstNameKana(data.value)) }
            />
            <ValidatorMessage target="applicant.first_name_kana"/>
          </Form.Field>
        </Form.Group>
        <Form.Field required>
          <label>申込時Eメールアドレス</label>
          <Input
            defaultValue={ corporation.applicant.email.value }
            onChange={ (event, data) => repository.setCorporationApplicantEmail(new Email(data.value)) }
          />
          <ValidatorMessage target="applicant.email_address"/>
        </Form.Field>

        <AddressFormField
          address={ corporation.address }
          setPostalCode={ (postalCode: PostalCode) => repository.setCorporationAddressPostalCode(postalCode) }
          setPrefecture={ (prefecture: Prefecture) => repository.setCorporationAddressPrefecture(prefecture) }
          setCity={ (city: City) => repository.setCorporationAddressCity(city) }
          setStreet={ (street: Street) => repository.setCorporationAddressStreet(street) }
          setBuilding={ (building: Building) => repository.setCorporationAddressBuilding(building) }
        />
      </Form>
    </>
  )
};

export default CorporationSettingForm;
